import * as queryString from 'query-string';

const countyAggregate = {
    field: 'collected',
    name: 'collected_stats',
    groupName: 'group_by_county',
    groupField: 'county.keyword',
    size: 20,
};

const municipalityAggregate = {
    field: 'collected',
    name: 'collected_stats',
    groupName: 'group_by_municipality',
    groupField: 'municipality.keyword',
    size: 356,
};

const suburbAggregate = {
    field: 'collected',
    name: 'collected_stats',
    groupName: 'group_by_suburb',
    groupField: 'suburb.keyword',
    size: 20,
};

export const performSearch = async ({
    searchString,
    baseUrl,
    county,
    municipality,
    suburb,
    eventIds,
    geohash,
    from = 0,
    max = 50,
    sort,
}) => {
    const aggregates = {
        buckets: [countyAggregate],
        metrics: [],
    };
    if (county) {
        aggregates.buckets.push(municipalityAggregate);
    }
    if (municipality) {
        aggregates.buckets.push(suburbAggregate);
    }
    const filter = {
        event_id: eventIds,
        ...(county ? { 'county.keyword': county } : {}),
        ...(municipality ? { 'municipality.keyword': municipality } : {}),
        ...(suburb ? { 'suburb.keyword': suburb } : {}),
    };
    const query = queryString.stringify({
        q: searchString,
        geohash,
        filter: JSON.stringify(filter),
        max,
        from,
        aggregations: JSON.stringify(aggregates),
        sort,
    });
    const fullUrl = `${baseUrl}/api/public/search/projects/selection-search?${query}`;
    const response = await fetch(fullUrl);
    if (response.ok) {
        const json = await response.json();
        return {
            projects: json.projects,
            counties: json.aggregationResults.group_by_county,
            municipalities: json.aggregationResults.group_by_municipality,
            suburbs: json.aggregationResults.group_by_suburb,
            total: json.total,
        };
    } else {
        return {};
    }
};

export const searchForArea = async ({ baseUrl, name }) => {
    const query = queryString.stringify({ name });
    const fullUrl = baseUrl.concat(`/api/public/location/area?${query}`);
    try {
        const response = await fetch(fullUrl);
        return await response.json();
    } catch (e) {
        return null;
    }
};

export const fetchMunicipalities = async ({ baseUrl, eventIds }) => {
    const aggregates = {
        buckets: [municipalityAggregate],
        metrics: [],
    };
    const filter = {
        event_id: eventIds,
    };

    const query = queryString.stringify({
        filter: JSON.stringify(filter),
        max: 0,
        aggregations: JSON.stringify(aggregates),
    });
    const fullUrl = `${baseUrl}/api/public/search/projects/selection-search?${query}`;
    return fetch(fullUrl);
};

export const fetchPopulation = async ({ county = '', municipality = '', suburb = '', baseUrl }) => {
    const fullUrl = `${baseUrl}/api/public/location/population?countyName=${county}&municipalityName=${municipality}&suburb=${suburb}`;

    if (!county && !municipality) {
        return null;
    }

    const response = await fetch(fullUrl);
    if (response.ok) {
        return await response.json();
    } else {
        return null;
    }
};
